import Diamond from '../src/Diamond/index';
export default Diamond;
